import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';

export const fetchGoals = createAsyncThunk('goals/fetchGoals', async () => {
  const { data } = await axiosInstance.get('/goals');
  return data;
});

export const createGoal = createAsyncThunk('goals/createGoal', async (goalData) => {
  const { data } = await axiosInstance.post('/goals', goalData);
  return data;
});

export const updateGoal = createAsyncThunk('goals/updateGoal', async ({ id, ...goalData }) => {
  const { data } = await axiosInstance.put(`/goals/${id}`, goalData);
  return data;
});

export const deleteGoal = createAsyncThunk('goals/deleteGoal', async (id) => {
  await axiosInstance.delete(`/goals/${id}`);
  return id;
});

const initialState = {
  goals: [],
  loading: { goals: false, creating: false, updating: false, deleting: false },
  error: null,
  selectedGoal: null,
};

const goalSlice = createSlice({
  name: 'goals',
  initialState,
  reducers: {
    setSelectedGoal: (state, action) => { state.selectedGoal = action.payload; },
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGoals.pending, (state) => { state.loading.goals = true; })
      .addCase(fetchGoals.fulfilled, (state, action) => { 
        state.loading.goals = false; 
        state.goals = action.payload; 
      })
      .addCase(fetchGoals.rejected, (state, action) => { 
        state.loading.goals = false; 
        state.error = action.error.message; 
      })
      .addCase(createGoal.fulfilled, (state, action) => { 
        state.goals.push(action.payload); 
      })
      .addCase(updateGoal.fulfilled, (state, action) => {
        const index = state.goals.findIndex(g => g.id === action.payload.id);
        if (index !== -1) state.goals[index] = action.payload;
      })
      .addCase(deleteGoal.fulfilled, (state, action) => {
        state.goals = state.goals.filter(g => g.id !== action.payload);
      });
  },
});

export const { setSelectedGoal, clearError } = goalSlice.actions;
export const selectGoals = (state) => state.goals.goals;
export const selectGoalLoading = (state) => state.goals.loading;
export default goalSlice.reducer; 